var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classNames,style:({
      cursor: _vm.styleCursor,
      'user-select': _vm.styleUserSelect,
    }),on:{"mousedown":_vm.onMouseDown,"touchstart":_vm.onMouseDown}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }